/**
 * Foundation/Core — Suite Launcher catalog
 *
 * Catalogo di default dei moduli della Gruppo Impresa Suite.
 * Utilizzabile da qualsiasi Product Pack per popolare il SuiteLauncher.
 *
 * `defaultSuiteModules(urls)` produce l'elenco standard delle applicazioni Suite
 * con nome, tagline, icona, colore, status.
 *
 * NB: la funzione accetta la mappa `urls` come input — il resolver degli URL
 * (locale vs produzione) NON e' responsabilita' del CORE launcher, viene
 * risolto dal chiamante (tipicamente un helper Foundation dedicato) e passato
 * qui gia' materializzato. Questo evita accoppiamenti a policy di ambiente
 * dentro il launcher.
 */
import {
  Building2,
  CheckCircle2,
  Cloud,
  FileSpreadsheet,
  FolderArchive,
  Sparkles,
  UsersRound,
} from "lucide-react";

export function defaultSuiteModules(urls = {}) {
  return [
    {
      key: "studio",
      name: "GI Studio",
      tagline: "Pratiche e attività dello studio",
      icon: Building2,
      color: "#397053",
      status: "active",
      url: urls.studio,
    },
    {
      key: "presenze",
      name: "GI Presenze",
      tagline: "Gestione presenze, assenze e banca ore",
      icon: CheckCircle2,
      color: "#69b34c",
      status: "active",
      url: urls.presenze,
    },
    {
      key: "pagamenti",
      name: "GI Finance",
      tagline: "Incassi, pagamenti, scadenze e prima nota",
      icon: FileSpreadsheet,
      color: "#5795be",
      status: "active",
      url: urls.pagamenti,
    },
    {
      key: "connect",
      name: "GI Connect",
      tagline: "Portale online per cedolini, CU e comunicazioni",
      icon: Cloud,
      color: "#278d83",
      status: "planned",
    },
    {
      key: "documenti",
      name: "GI Documenti",
      tagline: "La memoria digitale dello Studio",
      icon: FolderArchive,
      color: "#6689dc",
      status: "planned",
    },
    {
      key: "ai-assistant",
      name: "GI AI Assistant",
      tagline: "Assistente intelligente trasversale alla Suite",
      icon: Sparkles,
      color: "#15192c",
      status: "planned",
    },
    {
      key: "clienti",
      name: "GI Clienti",
      tagline: "Anagrafiche, relazioni e servizi dedicati ai clienti",
      icon: UsersRound,
      color: "#5d94ae",
      status: "planned",
    },
  ];
}
